.buttonContainer {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;
	gap: 7px;
	box-sizing: border-box;

	width: fit-content;
	border-radius: 5px;
	border-width: 2px;
	border-style: solid;

	background-color: #ffffff;

	transition: all cubic-bezier(0.4, 0, 0.2, 1) 250ms;

	.buttonIcon {
		width: 24px;
		height: 24px;
		box-sizing: border-box;
	}

	.buttonText {
		font-weight: 400;
		font-size: 15px;
		line-height: 150%;
		letter-spacing: 0px;
	}

	&.small {
		height: 35px;
		padding: 6px 15px;
	}

	&.medium {
		height: 40px;
		padding: 8px 15px;
	}

	&.large {
		height: 47px;
		padding: 12px 20px;
	}

	&.login {
		width: 450px;
		height: 60px;
		padding: 8px 20px;
	}

	svg {
		fill: currentColor;
		stroke: currentColor;
	}

	&:hover:not(:disabled) {
		cursor: pointer;
	}

	&:disabled {
		cursor: not-allowed;
	}

	&.primary {
		color: #42296e;
		border: 2px solid #42296e;

		&:hover:not(:disabled) {
			background-color: #42296e;
			color: #ffffff;
		}

		&:disabled {
			border-color: #c2bbcf;
			background-color: #c2bbcf;
			color: #54476b;
		}
	}

	&.secondary {
		color: #0b6f85;
		border: 2px solid #0b6f85;

		&:hover:not(:disabled) {
			background-color: #0b6f85;
			color: #ffffff;
		}

		&:disabled {
			border-color: #b0cbd1;
			background-color: #b0cbd1;
			color: #305963;
		}
	}

	&.delete {
		color: #bf0033;
		border: 2px solid #bf0033;

		&:hover:not(:disabled) {
			background-color: #bf0033;
			color: #ffffff;
		}

		&:disabled {
			border-color: #e8aebe;
			background-color: #e8aebe;
			color: #bf0033;
		}
	}

	&:active {
		filter: brightness(0.75);
	}

	&:focus-visible {
		outline: 2px solid var(--focus-outline-color-dark);
		outline-offset: 2px;
	}
}
